import { render, staticRenderFns } from "./CanvaComponent.vue?vue&type=template&id=1ae93d71&scoped=true&"
import script from "./CanvaComponent.vue?vue&type=script&lang=js&"
export * from "./CanvaComponent.vue?vue&type=script&lang=js&"
import style0 from "./CanvaComponent.vue?vue&type=style&index=0&id=1ae93d71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae93d71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VIcon,VSpacer})
